<script setup lang="ts">
import { computed, type Component } from 'vue';
import { DOCUMENT } from '@pkg/config/sanity/schemas';
import { documentToFieldName } from '@pkg/sanity-utils/documentToFieldName';

import {
  LISTING_TYPES,
  SHORT_LISTING_POSTS_NUMBER,
  FULL_LISTING_POSTS_NUMBER,
  MEDIA_ASSETS_POSTS_NUMBER,
} from '@pkg/types/listing';

const props = defineProps<{
  block?: {
    listingDocument: string,
    listingType?: LISTING_TYPES,
    listingFilter: string,
    categorySelection?: string,
    _key?: string,
  },
  config: {
    innerComponent?: Component
  },
}>();

const data = computed(() => ({
    listingDocument: props.block?.listingDocument,
    listingFilter: blockListingTaxonomy(props.block?.listingDocument),
    listingType: props.block?.listingType,
    postsPerPage: setPostsPerPage(props.block?.listingType, props.block?.listingDocument),
    categorySelection: props.block?.categorySelection,
    sanityKey: props.block?._key
}));

const blockListingTaxonomy = (document: string | undefined) => document && true && props.block?.[`listingFilter_${documentToFieldName(document)}` as keyof { listingFilter: string }];

const setPostsPerPage = (listingType: LISTING_TYPES | undefined, listingDocument = '') => {
  
  if (listingType && listingType === LISTING_TYPES.LATEST) return SHORT_LISTING_POSTS_NUMBER;

  switch(listingDocument) {
    case DOCUMENT.ABOUT_FOOD_WASTE_BLOG:
      return FULL_LISTING_POSTS_NUMBER;

    case DOCUMENT.ABOUT_FOOD_WASTE_RESOURCES:
      return FULL_LISTING_POSTS_NUMBER;

    case DOCUMENT.PRESS_RELEASES:
      return SHORT_LISTING_POSTS_NUMBER;

    case DOCUMENT.PRESS_NEWS_COVERAGE:
      return SHORT_LISTING_POSTS_NUMBER;

    case DOCUMENT.PRESS_MEDIA_ASSETS:
      return MEDIA_ASSETS_POSTS_NUMBER;

    default:
      return FULL_LISTING_POSTS_NUMBER;
  }
}
</script>

<template>
  <component :is="props.config?.innerComponent" v-bind="data"/>
</template>
